import React from 'react';
import Grid from '@material-ui/core/Grid';

import images from '@/assets/images';
import useStyles from './styles';

const NoExpenses = ({ title }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction="column"
      justify="center"
      alignItems="center"
      spacing={10}
      style={{ marginBottom: 40 }}
    >
      <Grid item>
        <img src={images.noProducts} width={151} height={151} />
      </Grid>
      <Grid item>
        <span className={classes.emptyAddonsText}>{title}</span>
      </Grid>
    </Grid>
  );
};

export default NoExpenses;
